export const HINT_DEFERRED = 'deferred';
export const HINT_ACCEPTED = 'accepted';
export const HINT_PENDING = 'pending';
export const HINT_REJECTED = 'rejected';
export const HINT_STATE_BY_ID = {
	0: HINT_ACCEPTED,
	2: HINT_PENDING,
	3: HINT_REJECTED,
	5: HINT_DEFERRED
};
